module.exports = __webpack_public_path__ + "fonts/hk-grotesk.regular.2a243cd5.ttf";